export default __webpack_public_path__ + "dot-net.4601ecd4.png";